module.exports = __webpack_public_path__ + "static/media/slider_porque_icon4.0599a6ce.svg";